import { useState } from 'react';
import { GeoclientApi } from '../../../api/GeoclientApi';
import { AiOutlineSetting } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { BiLinkExternal } from 'react-icons/bi';

const GeoclientAuth = ({ isAuth, onAuth, setQuotes, onLogout }) => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [remember, setRemember] = useState(false);
  const [isSettingsOpened, setSettingsOpened] = useState(false);

  const quotesInCRMLink = 'https://crm.geograftour.com/quotes';

  const toggleSettingsOpened = () => {
    setSettingsOpened(!isSettingsOpened);
  };

  const authentificate = function () {
    const form = new FormData();
    form.append('login', login);
    form.append('password', password);
    GeoclientApi.login(form)
      .then((result) => {
        if (result.auth) {
          if (result.token) {
            setQuotes([]);

            localStorage.setItem('token', result.token);
            onAuth(true, result.user, result.token);

            if (remember) {
              localStorage.setItem('refresh', result.refresh);
            } else {
              localStorage.removeItem('refresh');
            }
          }
        } else {
          setErrorMessage(result.error);
        }
      })
      .catch((e) => {
        if (e.status === 400) {
          setErrorMessage('Ошибка запроса, обновите страницу');
        } else if (e.status === 401) {
          setErrorMessage('Неверный логин или пароль');
        } else if (e.status === 500) {
          setErrorMessage('Ошибка сервера, попробуйте позже');
        } else {
          setErrorMessage(e.statusText);
        }
      });
  };
  const handleRemember = (event) => {
    setRemember(event.target.checked); // Обновляем состояние при изменении значения чекбокса
  };

  const handleLogout = () => {
    setQuotes([]);
    onAuth(false);
    setSettingsOpened(false);
    onLogout();

    localStorage.removeItem('token');
    if (localStorage.getItem('refresh')) {
      localStorage.removeItem('refresh');
    }
    if (localStorage.getItem('tourStack')) {
      localStorage.setItem('tourStack', JSON.stringify([]));
    }
  };

  return (
    <div id="geoclient-auth" className="geoclient-auth">
      {isAuth ? (
        <>
          <Link className="quotes-link" to={quotesInCRMLink} target="_blank">
            Подборки в CRM <BiLinkExternal />
          </Link>
          <button
            id="logout"
            className={`geoclient__exit-btn${
              isSettingsOpened ? ' geoclient__exit-btn_visible' : ''
            }`}
            onClick={handleLogout}
          >
            Выйти
          </button>
          <button
            className="geoclient__auth-control"
            onClick={toggleSettingsOpened}
          >
            <AiOutlineSetting />
          </button>
        </>
      ) : (
        <>
          <div className="auth__form">
            <form name="geoclient-auth" className="geoclient__auth-form">
              <label className="form-row">
                <input
                  type="text"
                  name="login"
                  autoFocus
                  placeholder="Логин"
                  required
                  value={login}
                  onChange={(e) => {
                    setLogin(e.target.value);
                    setErrorMessage('');
                  }}
                />
              </label>
              <label className="form-row">
                <input
                  type="password"
                  name="password"
                  placeholder="Пароль"
                  required
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setErrorMessage('');
                  }}
                />
              </label>
              <div className="geoclient__auth-submit-container">
                <button
                  className="btn"
                  type="submit"
                  id="signin"
                  name="signin"
                  onClick={(e) => {
                    e.preventDefault();
                    authentificate();
                  }}
                >
                  Войти
                </button>
                <label htmlFor="remember">
                  <input
                    type="checkbox"
                    id="remember"
                    name="remember"
                    defaultChecked={remember}
                    onClick={handleRemember}
                  />
                  <span>Запомнить</span>
                </label>
              </div>
            </form>
          </div>
          {errorMessage && <p className="error">{errorMessage}</p>}
        </>
      )}
    </div>
  );
};

export default GeoclientAuth;
